const styles = theme => ({
  header: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      padding: '16px',
    },
    backgroundColor: '#F5F5F5',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #D5D6D7',
    '& $headerTitle:nth-child(1)': {
      flexBasis: '25%',
    },
    '& $headerTitle:nth-child(2)': {
      flexBasis: '25%',
    },
    '& $headerTitle:nth-child(3)': {
      flexBasis: '50%',
    },
  },
  headerTitle: {
    color: '#000000',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
    },
  },

  body: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  tabs: {
    flexBasis: '25%',
    borderRight: '1px solid #D5D6D7',
    borderRadius: 0,
    '& .MuiTabs-indicator': {
      display: 'none !important',
    },
  },
  tab: {
    width: '100%',
    margin: 0,
    minWidth: 'auto',
    minHeight: 'auto',
    maxWidth: 'none',
    padding: '20px 24px',
    borderRadius: '0 !important',
    opacity: '1 !important',
    backgroundColor: theme.palette.primary.white,
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
  },

  tabActive: {
    backgroundColor: '#0088FF',
    '& $tabTitle': {
      color: theme.palette.primary.white,
    },
  },

  tabTitleContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  tabTitle: {
    color: '#000000',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    textAlign: 'left',
  },

  tabArrowIcon: {
    '& svg': {
      width: '16px',
      height: '17px',
    },
  },

  serviceAndPermissionsContainer: {
    flexBasis: '75%',
    '& $serviceContainer:nth-child(even) ': {
      backgroundColor: 'rgba(13, 42, 58, 0.02)',
    },
  },

  serviceContainer: {
    backgroundColor: theme.palette.primary.white,
    display: 'flex',
    alignItems: 'flex-start',
    borderBottom: '1px solid #D5D6D7',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  serviceName: {
    flexBasis: '33.3334%',
    color: '#595B61',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    textAlign: 'left',
    padding: '32px 24px',
  },
  permissionContainer: {
    flex: 1,
    padding: '24px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    flexWrap: 'wrap',
  },
  permissionName: {
    backgroundColor: '#F5F5F5',
    display: 'inline-block',
    padding: '8px',
    color: '#595B61',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
  },
});

export default styles;
